import Vue from 'vue';
import Component from 'vue-class-component';

export enum UserQuotaStatus {
  NORMAL = 'normal',
  LIMIT_REACHED = 'limit_reached',
  LIMIT_EXCEEDED = 'limit_exceeded',
}

@Component
export default class UserQuotaMixin extends Vue {
  public userQuotaUsed = 0;

  public userQuotaLimit = 0;

  get userQuotaStatus(): UserQuotaStatus {
    if (this.userQuotaLimit === 0) {
      return UserQuotaStatus.NORMAL;
    }

    if (this.userQuotaUsed > this.userQuotaLimit) {
      return UserQuotaStatus.LIMIT_EXCEEDED;
    }

    if (this.userQuotaUsed === this.userQuotaLimit) {
      return UserQuotaStatus.LIMIT_REACHED;
    }

    return UserQuotaStatus.NORMAL;
  }

  get hasUserQuotaLimitReached(): boolean {
    return this.userQuotaStatus === UserQuotaStatus.LIMIT_REACHED;
  }

  get hasUserQuotaExceeded(): boolean {
    return this.userQuotaStatus === UserQuotaStatus.LIMIT_EXCEEDED;
  }

  get hasUserQuotaIssue(): boolean {
    return this.hasUserQuotaLimitReached || this.hasUserQuotaExceeded;
  }

  public async fetchUserQuotaConsumption(): Promise<void> {
    try {
      const { data } = await this.$http.get(process.env.VUE_APP_GENERAL_CONSUMPTION);
      const consumption = Array.isArray(data) ? data[0] : data;
      this.userQuotaUsed = consumption?.softwarePlan?.users?.totalSpent || 0;
      this.userQuotaLimit = consumption?.softwarePlan?.users?.limit || 0;
    } catch (error) {
      this.userQuotaUsed = 0;
      this.userQuotaLimit = 0;
    }
  }
}
